import { h } from "omi";

import { IconProps } from "@/wc/components";

export function CopyIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21" width={width} height={height}>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.66667"
        d="M4.16675 13c-.77657 0-1.16486 0-1.47114-.1269-.40838-.1692-.73284-.4936-.90199-.902-.12687-.3063-.12687-.6946-.12687-1.4711V4.83329c0-.93342 0-1.40013.18165-1.75665a1.666713 1.666713 0 0 1 .72836-.72836c.35652-.18165.82323-.18165 1.75665-.18165h5.66669c.7766 0 1.1648 0 1.4711.12686.4084.16916.7329.49362.902.902.1269.30628.1269.69457.1269 1.47114M10.1667 18.8333h5.5c.9335 0 1.4002 0 1.7567-.1817.3136-.1598.5686-.4147.7284-.7283.1816-.3565.1816-.8233.1816-1.7567v-5.5c0-.93339 0-1.4001-.1816-1.75662-.1598-.31361-.4148-.56858-.7284-.72836-.3565-.18166-.8232-.18166-1.7567-.18166h-5.5c-.93337 0-1.40008 0-1.7566.18166-.31361.15978-.56857.41475-.72836.72836-.18166.35652-.18166.82323-.18166 1.75662v5.5c0 .9334 0 1.4002.18166 1.7567.15979.3136.41475.5685.72836.7283.35652.1817.82323.1817 1.7566.1817Z"
      />
    </svg>
  );
}
